import React from 'react';

import { Svg, type SvgProps } from './svg';

export function CollapseIcon(props: SvgProps) {
  return (
    <Svg data-testid="collapse-icon" {...props}>
      <path d="M24 1.692L17.652 8.04L21.6 12H12V2.4L15.948 6.348L22.308 0L24 1.692ZM1.692 24L8.04 17.652L12 21.6V12H2.4L6.348 15.948L0 22.308L1.692 24Z" />
    </Svg>
  );
}
